import { defineComponent as r, createBlock as n, openBlock as a, normalizeProps as p, guardReactiveProps as l, withCtx as s, renderSlot as c, createElementVNode as d } from "vue";
import m from "../CdrIcon.vue.mjs";
const f = /* @__PURE__ */ r({
  name: "CaretDown",
  __name: "caret-down",
  props: {
    props: {
      type: Object
    }
  },
  setup(t) {
    return (o, e) => (a(), n(m, p(l(t.props)), {
      default: s(() => [c(o.$slots, "default"), e[0] || (e[0] = d("path", {
        role: "presentation",
        d: "M12 16c.273 0 .521-.11.702-.288l5.005-5.005a1 1 0 00-1.414-1.414L12 13.586 7.705 9.29a1 1 0 00-1.412 1.417l4.98 4.98c.182.193.44.313.727.313z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
